import axios from '@/axios';

export const CategoryApi = {
  /**
   * 카테고리 목록 조회
   * @param {Object} params - 검색 파라미터
   * @param {number} [params.page] - 페이지 번호
   * @param {number} [params.limit] - 페이지 크기
   * @param {string} [params.name] - 카테고리명 검색어
   * @param {string} [params.department] - 진료과목 필터
   * @param {string} [params.useFilter] - 사용 여부 필터 (certificate/hospital)
   * @returns {Promise}
   */
  getCategoryList: async (params = {}) => {
    return await axios.get('/product-v2/categories', { params });
  },

  /**
   * 카테고리 상세 조회
   * @param {string} categoryId - 카테고리 ID
   * @returns {Promise}
   */
  getCategory: async (categoryId) => {
    return await axios.get(`/product-v2/categories/${categoryId}`);
  },

  /**
   * 카테고리 생성
   * @param {Object} categoryData - 카테고리 데이터
   * @param {string} categoryData.name - 카테고리명
   * @param {Object} [categoryData.names] - 카테고리 다국어 이름
   * @param {string} [categoryData.names.ko] - 한국어 카테고리명
   * @param {string} [categoryData.names.en] - 영어 카테고리명
   * @param {string} [categoryData.names.ja] - 일본어 카테고리명
   * @param {string} [categoryData.names.zh] - 중국어 카테고리명
   * @param {string} categoryData.description - 설명
   * @param {string} categoryData.department - 진료과목
   * @param {boolean} categoryData.useCertificate - 인증서 사용 여부
   * @param {boolean} categoryData.useHospital - 병원 예약 사용 여부
   * @param {string} categoryData.activeFontColor - 활성 폰트 색상
   * @param {string} categoryData.inactiveFontColor - 비활성 폰트 색상
   * @param {string} categoryData.activeImage - 활성 이미지 URL
   * @param {string} categoryData.inactiveImage - 비활성 이미지 URL
   * @returns {Promise}
   */
  createCategory: async (categoryData) => {
    return await axios.post('/product-v2/categories', categoryData);
  },

  /**
   * 카테고리 수정
   * @param {string} categoryId - 카테고리 ID
   * @param {Object} categoryData - 카테고리 데이터
   * @param {string} categoryData.name - 카테고리명
   * @param {Object} [categoryData.names] - 카테고리 다국어 이름
   * @param {string} [categoryData.names.ko] - 한국어 카테고리명
   * @param {string} [categoryData.names.en] - 영어 카테고리명
   * @param {string} [categoryData.names.ja] - 일본어 카테고리명
   * @param {string} [categoryData.names.zh] - 중국어 카테고리명
   * @param {string} categoryData.description - 설명
   * @param {string} categoryData.department - 진료과목
   * @param {boolean} categoryData.useCertificate - 인증서 사용 여부
   * @param {boolean} categoryData.useHospital - 병원 예약 사용 여부
   * @param {string} categoryData.activeFontColor - 활성 폰트 색상
   * @param {string} categoryData.inactiveFontColor - 비활성 폰트 색상
   * @param {string} categoryData.activeImage - 활성 이미지 URL
   * @param {string} categoryData.inactiveImage - 비활성 이미지 URL
   * @returns {Promise}
   */
  updateCategory: async (categoryId, categoryData) => {
    return await axios.put(`/product-v2/categories/${categoryId}`, categoryData);
  },

  /**
   * 카테고리 삭제
   * @param {string} categoryId - 카테고리 ID
   * @returns {Promise}
   */
  deleteCategory: async (categoryId) => {
    return await axios.delete(`/product-v2/categories/${categoryId}`);
  },
  
  /**
   * 여러 카테고리 순서 일괄 변경
   * @param {Array<Object>} orderDataList - 순서 변경 데이터 배열
   * @param {string} orderDataList[].categoryId - 카테고리 ID
   * @param {number} orderDataList[].order - 변경할 순서 값
   * @returns {Promise}
   */
  updateCategoriesOrder: async (orderDataList) => {
    return await axios.post(`/product-v2/categories/order/batch-update`, { categories: orderDataList });
  },

  /**
   * 카테고리 코드 중복 체크
   * @param {string} code - 확인할 카테고리 코드
   * @param {string} [excludeId] - 제외할 카테고리 ID (수정 시 사용)
   * @returns {Promise}
   */
  checkCodeDuplicate: async (code, excludeId) => {
    const params = { code };
    if (excludeId) {
      params.excludeId = excludeId;
    }
    return await axios.get('/product-v2/categories/check-duplicate-code', { params });
  }
};
